import React, { useState } from 'react';
import find from 'lodash/find';
import ConfirmationModal from '../../../../common/modals/Confirmation';
import { APPLE_AUTH } from '../../../../../config/Master';
import Toggle from '../../../../../atoms/toggle/Toggle';
import { initGoogleScript } from '../../../../../utils/googleAuth';
import { appleAuth } from '../../../../../utils/appleAuth';

interface SliderAppleToggleProps {
  needsAccountPassword: any;
  social: any;
  attachSocialLogin: any;
  handleSidebarToggle: any;
  menuOpen: any;
  isDisabled: boolean;
}

const SliderAppleToggle = ({
  social,
  attachSocialLogin,
  handleSidebarToggle,
  menuOpen,
  isDisabled,
  needsAccountPassword,
}: SliderAppleToggleProps): any => {
  const [modalOpen, toggleModalOpen] = useState(false);

  const appleSso = find(social.data, { social_site_name: APPLE_AUTH }) || null;

  React.useEffect(() => {
    initGoogleScript();
  }, []);

  const attachAppleSso = async action => {
    try {
      if (action !== 'connect') {
        return attachSocialLogin({}, APPLE_AUTH, action);
      }

      await appleAuth(response => {
        setTimeout(() => {
          handleSidebarToggle(!menuOpen, true);
        }, 1000);
        attachSocialLogin(response, APPLE_AUTH, action);
      });
    } catch (e) {
      setTimeout(() => {
        handleSidebarToggle(!menuOpen, true);
      }, 1000);
      console.error(e);
    }
  };

  const handleToggleModal = openStatus => {
    toggleModalOpen(openStatus);
  };

  const handleDetachSocial = () => {
    toggleModalOpen(false);

    return attachAppleSso('disconnect');
  };

  const determineToggle = () => {
    appleSso ? handleToggleModal(true) : attachAppleSso('connect');
  };

  return (
    <div>
      <Toggle
        toggleId="apple_toggle"
        isChecked={Boolean(appleSso)}
        disabled={isDisabled || needsAccountPassword}
        onChange={determineToggle}
      />

      <ConfirmationModal
        contentLabel="Social Attachment Modal"
        shouldOpen={modalOpen}
        onCloseHandler={() => toggleModalOpen(false)}
        cancelBtnText="Nevermind"
        confirmationBtnText="Disconnect"
        confirmAction={handleDetachSocial}
      />
    </div>
  );
};

export default SliderAppleToggle;
